@if (constraintSpec$ | async; as constraintSpec) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (!embedded) {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <elder-header
            [header]="
              (creationMode ? 'skillSets.constraints.new' : 'skillSets.constraints.constraint')
                | translate
            "
            [subheader]="creationMode ? ' ' : 'ID: ' + constraintSpec.id"
          >
          </elder-header>
          <span class="flex"></span>
          <button mat-icon-button [disabled]="!constraintFrm.form.valid" (click)="onSave($event)">
            <mat-icon>save</mat-icon>
          </button>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <form #constraintFrm="ngForm" class="flex layout-col gap-xl p-xl">
      <div class="flex layout-row place-start-center gap-md">
        <mat-form-field elderDense>
          <mat-label>{{ 'properties.property' | translate }}</mat-label>
          <elder-select
            name="productProperty"
            appPropertySelect
            productKind
            class="flex"
            required
            [(ngModel)]="constraintSpec.property"
            (valueChange)="productPropertySelectionChanged($event)"
          >
            <div *elderSelectValue="let value" class="layout-col">
              <span style="line-height: 20px">{{ value.description }}</span>
              <span class="mat-caption">{{ value.id }}</span>
            </div>
            <app-property-browser *elderSelectionModelPopup class="flex" productKind>
            </app-property-browser>
          </elder-select>
        </mat-form-field>
      </div>
      <div class="flex layout-row place-start-center gap-md">
        <mat-form-field elderDense>
          <mat-label>{{ 'skillSets.constraints.operator' | translate }}</mat-label>
          <elder-select
            appConstraintOperatorSelect
            name="operator"
            class="flex"
            [currentSelectedProperty]="constraintSpec.property"
            required
            valueAsId
            [(ngModel)]="constraintSpec.operator"
          >
          </elder-select>
        </mat-form-field>
        <div class="flex layout-col">
          <mat-checkbox
            name="required"
            [(ngModel)]="constraintSpec.inputRequired"
            [labelPosition]="'after'"
          >
            {{ 'context.input-required' | translate }}
          </mat-checkbox>
          <mat-checkbox
            name="optional"
            [(ngModel)]="constraintSpec.matchIfMissingProp"
            [labelPosition]="'after'"
          >
            {{ 'context.optional' | translate }}
          </mat-checkbox>
          @if (PropertyUtil.supportsSingleSelectionSetting(constraintSpec?.property?.type)) {
            <mat-checkbox
              name="singleSelection"
              [(ngModel)]="constraintSpec.singleSelection"
              [labelPosition]="'after'"
            >
              {{ 'context.single-selection' | translate }}
            </mat-checkbox>
          }
        </div>
      </div>
      <div class="flex layout-row gap-md">
        <mat-form-field class="flex">
          <mat-label>{{ 'context.description' | translate }}</mat-label>
          <input
            matInput
            name="description"
            placeholder="{{ 'context.description' | translate }}"
            [(ngModel)]="constraintSpec.description"
          />
        </mat-form-field>
      </div>
    </form>
  </div>
}
